module.exports = __webpack_public_path__ + "img/lady.d5fdef0b.png";